// components/form-ui/card-wrapper.tsx
"use client";

import { BackButton } from "@/components/auth/back-button";
import { Header } from "@/components/auth/header";
import { Social } from "@/components/form-ui/social";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { getLanguageCookie } from "@/data/cookieClient";
import { LanguageType } from "@/lib/types";
import { cn } from "@/lib/utils";

interface CardWrapperInterface {
  children: React.ReactNode;
  headerLabel: string;
  backButtonLabel?: string;
  backButtonHref?: string;
  showSocial?: boolean;
  width?: number;
  logo?: boolean;
  language?:LanguageType;
  classNames?: string;
}

export const CardWrapper: React.FC<CardWrapperInterface> = ({
  children,
  headerLabel,
  backButtonHref,
  backButtonLabel,
  showSocial,
  width = 400,
  logo = true,
  language=getLanguageCookie(),
  classNames
}) => {

  

  return (
    // cn() (tailwind-merge) so a caller's own width/rounding/shadow classes
    // in classNames actually replace these defaults instead of just
    // stacking alongside them -- plain string concatenation here used to
    // mean a fixed w-[350px] always won regardless of what was passed in.
    <Card className={cn("w-[350px] shadow-md", classNames)}>

      <CardHeader>
        <Header logo={logo} label={headerLabel} />
      </CardHeader>

      <CardContent>{children}</CardContent>

      {showSocial && (
        <CardFooter>
          <Social lang={language}/>
        </CardFooter>
      )}

      {backButtonHref && backButtonLabel && (
        <CardFooter>
          <BackButton label={backButtonLabel} href={backButtonHref} />
        </CardFooter>
      )}
    </Card>
  );
};
